module.exports = __webpack_public_path__ + "static/media/2-bumazhnoe.ec3e7c75.jpg";